import { createContext, useContext } from 'react';

export interface NewOrderLoadingContextType {
  isUpdatingFulfillment: boolean;
  isUpdatingQuantity: boolean;
}

export const NewOrderLoadingContext =
  createContext<NewOrderLoadingContextType | null>(null);

export const useNewOrderLoadingContext = () => {
  const context = useContext(NewOrderLoadingContext);
  if (!context) {
    throw new Error(
      'useNewOrderLoadingContext requires a NewOrderLoadingContextProvider',
    );
  }

  return context;
};
